export type StrokeWidth = number;
export type StrokeColor = string;

/**
 * Last-resort stroke color when no default is configured. Also the value
 * `FabricSlideCanvasComponent` falls back to, so palette and canvas always agree.
 */
export const FALLBACK_STROKE_COLOR: StrokeColor = '#000000';
export type ColorOption = { color: StrokeColor, border?: boolean };
export type DrawingToolName = 'selection' | 'pencil' | 'ellipse' | 'arrow';
/**
 * Saved place of the floating toolbar: distance (px) of its bottom-right corner from the frame's right / bottom edge
 * (frame = the fixed containing block = the visible layout viewport without scrollbars).
 */
export type ToolbarPosition = { right: number, bottom: number };

export interface DrawingToolConfig {
    strokeWidth: StrokeWidth;
    //** Color to draw inside "svg-canvas.component" */
    strokeColor: StrokeColor | null;
    toolbarPosition: ToolbarPosition | null;
}
